import { Link } from "react-router-dom";
import { ArrowRight, Search, TrendingUp, Briefcase, Camera, Building2 } from "lucide-react";
import PageHero from "@/components/common/PageHero";
import { IMAGES } from "@/data/site";

const SERVICES = [
  {
    icon: Search,
    n: "01",
    title: "Scouting",
    intro: "A nossa área de scouting trabalha na identificação, observação e avaliação de jogadores, procurando analisar o rendimento atual e o potencial de desenvolvimento de cada atleta.",
    items: [
      "Identificação de jovens talentos",
      "Observação presencial",
      "Análise de jogos",
      "Análise de vídeo",
      "Avaliação técnica",
      "Avaliação tática",
      "Avaliação física",
      "Avaliação comportamental",
      "Relatórios de scouting",
      "Avaliação de desempenho",
      "Monitorização contínua",
    ],
    cta: { to: "/contactos", label: "Pedir avaliação" },
  },
  {
    icon: TrendingUp,
    n: "02",
    title: "Desenvolvimento do jogador",
    intro: "Acompanhamos cada atleta de forma individual, definindo objetivos e apoiando o seu desenvolvimento dentro e fora de campo.",
    items: [
      "Definição de objetivos",
      "Planeamento da evolução",
      "Acompanhamento desportivo",
      "Análise de desempenho",
      "Identificação de pontos fortes",
      "Identificação de áreas de melhoria",
      "Apoio na evolução competitiva",
      "Comunicação com o jogador e família",
    ],
  },
  {
    icon: Briefcase,
    n: "03",
    title: "Gestão de carreira",
    intro: "Apoiamos o jogador na construção de um percurso desportivo estruturado, responsável e adequado às suas características.",
    items: [
      "Planeamento da carreira",
      "Ligação entre atletas e clubes",
      "Apresentação de jogadores",
      "Apoio nas decisões profissionais",
      "Gestão de oportunidades",
      "Comunicação com clubes",
      "Acompanhamento em mudanças de clube",
      "Orientação ao longo da carreira",
    ],
  },
  {
    icon: Camera,
    n: "04",
    title: "Branding pessoal",
    intro: "A imagem profissional de um atleta influencia a forma como é apresentado e percecionado no mercado.",
    items: [
      "Construção da identidade profissional",
      "Criação de portefólios",
      "Organização de estatísticas",
      "Produção de vídeos de apresentação",
      "Orientação das redes sociais",
      "Comunicação digital",
      "Preparação de conteúdos",
      "Gestão da imagem profissional",
    ],
  },
  {
    icon: Building2,
    n: "05",
    title: "Serviços para clubes",
    intro: "Apoiamos clubes, academias e organizações desportivas no processo de recrutamento e monitorização de atletas.",
    items: [
      "Pesquisa de jogadores",
      "Pesquisa por posição",
      "Pesquisa por idade",
      "Pesquisa por nacionalidade",
      "Avaliação de atletas",
      "Relatórios técnicos",
      "Apresentação de perfis",
      "Monitorização de jogadores",
      "Apoio ao processo de recrutamento",
    ],
    cta: { to: "/clubes-parceiros", label: "Falar com o departamento de scouting" },
  },
];

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Serviços"
        title={<>Um serviço estruturado, <br /><span className="text-[#A67C00]">construído para durar</span></>}
        subtitle="Cinco áreas complementares que suportam o percurso do atleta e o trabalho dos clubes."
        image={IMAGES.training}
      />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 space-y-24">
        {SERVICES.map((s, idx) => (
          <section
            key={s.n}
            data-testid={`services-block-${s.n}`}
            className="grid md:grid-cols-12 gap-10 md:gap-16 border-b border-white/5 pb-24 last:border-0 last:pb-0"
          >
            <div className="md:col-span-4 reveal">
              <div className="font-cinzel text-[#A67C00] text-6xl md:text-7xl mb-6">{s.n}</div>
              <s.icon size={32} className="text-[#A67C00] mb-6" strokeWidth={1.2} />
              <h2 className="font-cinzel uppercase text-white text-3xl md:text-4xl tracking-tight mb-6">{s.title}</h2>
              <p className="text-neutral-400 text-sm leading-relaxed">{s.intro}</p>
              {s.cta && (
                <Link to={s.cta.to} data-testid={`services-cta-${s.n}`} className="btn-gold mt-8">
                  {s.cta.label} <ArrowRight size={14} />
                </Link>
              )}
            </div>
            <div className="md:col-span-8 reveal">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5 border border-white/5">
                {s.items.map((it) => (
                  <li key={it} className="bg-[#0B0B0B] p-5 flex items-center gap-4 text-neutral-200 text-sm">
                    <span className="text-[#A67C00] text-xs">▸</span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ))}
      </div>
    </>
  );
}
